<template>
  <div class="main">
    <topImg title="走进格如灵" img="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/historyHorner/banner_history.jpg"></topImg>
    <div class="content">
      <h1>发展历程</h1>
      <div class="history">
        <div class="list" v-for="(item, index) in list" :key="item.title">
          <div class="icon" :style="'background-image: url(' + item.icon + ')'"></div>
          <div class="line" v-if="index < list.length - 1"></div>
          <div class="cont">
            <div class="title">{{ item.title }}</div>
            <div class="shortLine"></div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <!-- <div class="list more">
          <div class="icon"></div>
          <div class="cont">
            <div class="title"> 故事还在继续 </div>
            <div class="shortLine"></div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [
        {
          title: '2016',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_626901c60bf7a/851484108.png',
          desc: '构建全行业第一个基于一体机的VR教学方案，拉开VR互动学习时代的帷幕，获得松禾资本领投的天使轮融资。'
        },
        {
          title: '2017',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_626901c591de1/680067192.png',
          desc: '落地学校近50所，产品受到工信部、教育部好评，VR智慧课堂初见规模，获得中路资本、优格资本千万级PreA轮融资。'
        },
        {
          title: '2018',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_626901c5cc866/682166255.png',
          desc: '获得行业奖项若干，成为上榜Digi-capital的唯一中小学中国教育科技公司，获得海尔资本、道格资本A及A+轮融资。'
        },
        {
          title: '2019',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_626901c59550c/304257441.png',
          desc: '与中移动卓望集团、华为、联想、百度等达成全面战略合作，与海尔国际联合全面进军全球市场，完成全国第一个5G学校项目。'
        },
        {
          title: '2020',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_626901c5adacb/349851359.png',
          desc: '扩张职业教育，扩展销售渠道与终端，提升内容产能，持续谱写发展新篇章，并启动C端业务，获得丝路视觉、两创政府基金的战略融资。'
        },
        {
          title: '2021',
          icon: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/c9bcfb649b4ae4df9b8da96f3c7d2d22.png',
          desc: '中间件赋能、平台化扩张产品销售，赋能企业培训拓展新产品线，全面深耕XR+教育培训领域，多次荣获行业内奖项，在5G+XR新时代谱写发展新篇章。'
        },
        {
          title: '2022',
          icon: 'http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_626901c5df932/827176593.png',
          desc: '累计获得荣誉及奖项近 20 个，全面布局元宇宙教育，从产品、内容、方案到属地化的支撑、培训等全面的做好各个环节的服务与创新，保持持续的创造力及商业闭环能力，获得万兴产业基金、仓廪投资的C1+C2轮融资。'
        },
        {
          title: '2023',
          icon: require('@/assets/images/icon_2023.png'),
          desc: '与佳发教育达成战略合作，多次荣登元宇宙创新应用荣誉榜单，获得泰豪小蓝基金、合世家C3轮融资，开启元宇宙时代教育新征程。'
        },
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .banner {
    width: 100%;
    display: block;
  }
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 63px;
    h1{
      text-align: center;
      font-size: 28px;
      font-weight: 600;
      line-height: 40px;
      margin-bottom: 58px;
    }
    .history{
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-bottom: 90px;
      .list{
        min-height: 168px;
        display: flex;
        flex-direction: row;
        position: relative;
        padding-bottom: 30px;
        .icon{
          width: 30px;
          height: 30px;
          background-color: #ccc;
          margin-left: -14px;
          position: absolute;
          background-size: 100% 100%;
        }
        .line{
          width: 3px;
          height: 100%;
          background-image: url('./assets/icon_jixu.png');
        }
        .cont{
          width: 1093px;
          height: 100%;
          display: flex;
          flex-direction: column;
          margin-left: 35px;
          .title{
            margin: 4px 0;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 9px;
            font-weight: 500;
          }
          .shortLine{
            width: 27px;
            height: 4px;
            border-radius: 2px;
            background-color: #EF623D;
            margin-bottom: 12px;
            opacity: 0.59;
          }
          .desc{
            min-height: 90px;
            padding: 31px 28px;
            font-size: 16px;
            line-height: 29px;
            background: #F7FAFC;
            border-radius: 2px;
          }
        }
      }
      // .list.more{
      //   border-right-width: 0;
      //   .icon{
      //     background-image: url('http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_626906ec77cfe/685777932.png');
      //   }
      //   .cont{
      //     margin-left: 38px;
      //   }
      // }
    }
  }
}
@media (max-width: 1000px) {
  .main{
    .content {
      width: 748px;
      margin: 0 auto;
      padding-top: 63px;
      h1{
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        line-height: 40px;
        margin-bottom: 58px;
      }
      .history{
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        .list{
          min-height: 168px;
          display: flex;
          flex-direction: row;
          position: relative;
          padding-bottom: 30px;
          .icon{
            width: 30px;
            height: 30px;
            background-color: #ccc;
            margin-left: -14px;
            position: absolute;
          }
          .line{
            width: 3px;
            height: 100%;
            background-image: url('./assets/icon_jixu.png');
          }
          .cont{
            width: 640px;
            height: 100%;
            display: flex;
            flex-direction: column;
            margin-left: 35px;
            .title{
              margin: 4px 0;
              font-size: 16px;
              line-height: 22px;
              margin-bottom: 9px;
            }
            .shortLine{
              width: 27px;
              height: 4px;
              border-radius: 2px;
              background-color: #EF623D;
              margin-bottom: 12px;
              opacity: 0.59;
            }
            .desc{
              min-height: 90px;
              padding: 31px 28px;
              font-size: 16px;
              line-height: 29px;
              background: #F7FAFC;
              border-radius: 2px;
            }
          }
        }
        .list.more{
          border-right-width: 0;
          .icon{
            background-image: url('./assets/icon_more.png');
          }
          .cont{
            margin-left: 38px;
          }
        }
      }
    }
  }
}
</style>
